//noinspection TypeScriptCheckImport
import {TranslateUtils} from "../../translate.utils";

// fixme to mikhail ts to json
let translations = [
    require('./error.ts'),
    require('./thank.you.page.ts')
];

export const LOCALE = TranslateUtils.buildTranslatePack(translations);


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/translate/translations/en/index.ts